import { CourseCardWidgetElement } from './define-course-card-element';

export function registerCourseCardWidget() {
  if (typeof window === 'undefined') return;
  if (window.customElements.get('adipa-course-card-widget')) return;

  window.customElements.define('adipa-course-card-widget', CourseCardWidgetElement);
}
